export default {
    methods: {
        convertYoutubeUrlToEmbedUrl(url)
        {
            if (url.includes("youtu.be"))
            {
                return url.replace("youtu.be", "youtube.com/embed");
            }
            else
            {
                const urlParams = new URLSearchParams(new URL(url).search);
                const videoId = urlParams.get("v");
                return `//www.youtube.com/embed/${videoId}`;
            }
        }
    }
}